import { createContext } from "react";

const GymContext = createContext();

export default GymContext;
